<template>
    <div class="table-box td-fc">
        <el-table
        class="td-f1"
            :data="tableData"
            style="width: 100%;"
            height="400"
            border
            :default-sort="{prop: 'date', order: 'descending'}"
            :header-cell-style="getRowClass"
        >
            <template v-for="item in tableField">
                <el-table-column
                    :key="item.id"
                    :prop="item.field"
                    :label="item.label"
                    :width="item.width"
                    :align="item.align || 'left'"
                ></el-table-column>
            </template>
            <el-table-column
                fixed="right"
                label="是否通过"
                width="100"
                align="center"
            >
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.is_pass" type="success">是</el-tag>
                    <el-tag v-else type="danger">否</el-tag>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-box">
            <el-pagination
                background
                layout="sizes, prev, pager, next"
                :total="total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page"
                :page-sizes="[10, 20, 50, 100]">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import { totalTestReport } from "@/api/common";
import Lockr from "lockr";

export default {
    name: "gradeData",
    data() {
        return {
            tableField: [
                {
                    field: "id",
                    label: "序号",
                    align: "center",
                    width: 100
                },
                {
                    field: "edition_name",
                    label: "课程名称"
                },
                {
                    field: "create_time",
                    label: "测试时间",
                    align: "center"
                },
                {
                    field: "use_time",
                    label: "测试耗时",
                },
                {
                    field: "score",
                    label: "分数",
                    align: "center"
                }
            ],
            tableData: [],
            page: 1,
            limit: 10,
            total: 0
        };
    },
    methods: {
        async getDataSource() {
            let params = {
                token: Lockr.get("token"),
                page: this.page,
                limit: this.limit,
                type: this.$route.meta.type == "word" ? 1 : 2
            };
            let result = await totalTestReport(params);
            if (result.code === this.GLOBAL.Serve.SUCCESS_CODE) {
                this.tableData =  result.data.dataList;
                this.total = result.data.count;
            } else {
                this.$message({
                    message: result.msg,
                    type: "warning"
                });
            }
        },
        handleSizeChange (val) {
            this.page = 1
            this.limit = val
            this.getDataSource()
        },
        handleCurrentChange (val) {
            this.page = val
            this.getDataSource()
        },
        getRowClass({ rowIndex }) {
            if (rowIndex == 0) {
                return "background:RGB(43,195,185);color:#fff";
            } else {
                return "";
            }
        }
    },
    created() {
        this.getDataSource();
    }
};
</script>

<style scoped lang='less'>
.table-box{
    height: 100%;
}
.pagination-box{
    text-align: left;
    padding-top: 20px;
}
</style>